import React from 'react';
import styled from "styled-components";
import {ReactComponent as Icon} from '../assets/icons/iconmonstr-banknote-thin.svg';


const IconoPlus = styled(Icon)`
height: 24px;
fill: #fff;
`


const IconPlus = () => {
    return ( 
        <>
            <IconoPlus></IconoPlus>
        </>
     );
}
 
export default IconPlus;